import { render, staticRenderFns } from "./ModifyBinPepScore.vue?vue&type=template&id=7ebc31af&"
import script from "./ModifyBinPepScore.vue?vue&type=script&lang=js&"
export * from "./ModifyBinPepScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports